/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".infoIntroText[_ngcontent-%COMP%]{font-size:15px;text-align:justify}.mat-table[_ngcontent-%COMP%]{overflow:auto;border:1px}.mat-cell[_ngcontent-%COMP%], .mat-header-cell[_ngcontent-%COMP%]{height:auto;align:left;text-align:justify;padding:15px}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/hsd-ui/info-dialog/info-dialog.component.sass.shim.ngstyle.js.pre-build-optimizer.js